import React, {useEffect, useState} from 'react'
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {CART_EXCEL_FILE_DOWNLOAD, CART_EXCEL_FILE_UPLOAD} from "../costants/Urls";
import axios from 'axios'
import {NLoader} from "./NLoader";
import {fetchCartItems, setCartState} from '../actions/nCartAppActions'
import { Popover, OverlayTrigger } from 'react-bootstrap';


const NExcelFile  = props => {
  const max_file_size = 5242880;
  const { nuser, fetchCartItems, setCartState} = props
  const default_error = "Ощибка обработки файла. Убедитесь в правильности заполнения файла (Справка по нажатию на иконку '?'). Если ошибка повторяется обратитесь к администратору";
  const unexpect_error = "Ощибка сервера. Убедитесь в правильности заполнения файла (Справка по нажатию на иконку '?'). Если ошибка повторяется обратитесь к администратору";
  const help_text = "And here's some amazing content. It's very engaging. Right?"

  const handleClose = e =>{

    e.preventDefault();
  }

  const [file, setFile] = useState();
  const [file_error, setFileError] = useState("");
  const [file_result, setFileResult] = useState("");
  const [file_result_error, setFileResultError] = useState("");
  const [isLoading, setIsLoading] = useState(false);


  const popoverLeft = (
      <Popover id="popover-positioned-left" title="Загруить из Excel файла">
        <strong>Можно загрузить товары из .xls файла расчета Базис-Облако.</strong>
          <br/>Для примера файла можно скачать .xlsx файл  корзины <br/>(Обязателен только первый столбец файла - артикул товара).
      </Popover>
    );


  const isFileValid = (local_file) =>{

      if ((local_file)&&(local_file.size < max_file_size)&&((local_file.name.endsWith('.xlsx'))||(local_file.name.endsWith('.xls')))){

          return true;
      }

      return false;
  }

  const isButtonEnabled = ()=> {

      if ((file)&&(isFileValid(file))){

          return true;
      }

      return false;
  }

  function handleChange(event) {

      let cfile = event.target.files[0];

      if (isFileValid(cfile)){
          setFile(cfile);
          setFileError("");
      }else{
          setFileError("Размер файла превышает 5Mb или формат файла не соответствует .xlsx");
      }

      setFileResult("");
      setFileResultError("");

  }

  function handleSubmit(event) {

      event.preventDefault();
      if(file){
          setIsLoading(true);

          const post_config = {
            xsrfCookieName: 'csrftoken',
            xsrfHeaderName: 'X-CSRFToken',
            withCredentials: true,
            headers: {
                'content-type': 'multipart/form-data',
            },
          }

          const formData = new FormData();
          formData.append('file', file);
          formData.append('fileName', file.name);

          axios.post(CART_EXCEL_FILE_UPLOAD, formData, post_config).then((response) => {
              setIsLoading(false);

              if (response.status === 200 || response.status === 201){
                  if(response.data.success){
                    setFileResult(response.data.title);
                    setFile(null);
                  }else{
                      // обработанная ошибка
                      const err_title = ((response.data.title) && (response.data.title.length > 0)) ? response.data.title : default_error;
                      setFileResult("");
                      setFileResultError(err_title);
                  }

              } else {
                  // обработанная ошибка
                  const err_title = ((response.data.title) && (response.data.title.length > 0)) ? response.data.title : default_error;
                  setFileResult("");
                  setFileResultError(err_title);

              }
              setCartState('NOT_LOADED');
              fetchCartItems();

            }).catch(err=> {
                setIsLoading(false);
                // не обработанная ошибка
                setFileResult("");
                setFileResultError(unexpect_error);

                setCartState('NOT_LOADED');
                fetchCartItems();
        });


      }

  }

  return (
      <div>
      { nuser.is_special === true &&
          <div>
                  <div className="nheader">
                      <div className="row">
                          <div className="col-md-6">
                              <a href={CART_EXCEL_FILE_DOWNLOAD} className='excel-save' target='_blank'>
                                  Сохранить корзину в файл .xlsx <i className="material-icons">attach_file</i></a>
                          </div>
                      </div>
                  </div>
                  <div className="nheader">

                      {file_result.length > 0 &&
                      <div className="row">
                          <div className="file-allert text-center">
                              {file_result}
                          </div>
                      </div>
                      }
                      {file_result_error.length > 0 &&
                      <div className="row">
                          <div className="file-allert text-center">
                              {file_result_error}
                          </div>
                      </div>
                      }

                      {file_error.length > 0 &&
                      <div className="row">
                          <div className="file-allert text-center">
                              {file_error}
                          </div>
                      </div>
                      }
                      <div className="row">
                          <div className="col-md-6">
                              <h2>Загрузить корзину из файла .xls/.xlsx</h2>
                          </div>
                          <div className="col-md-6">
                              <form className="form-inline" onSubmit={handleSubmit}>
                                  <div className="form-group">
                                      <input className="form-control" type="file" onChange={handleChange} accept='.xls, .xlsx'/>
                                  </div>
                                  {isLoading ?
                                        <div className="form-group"><NLoader size="pl-size-xs" /> </div>
                                      :
                                        <button className={`btn excel-submit${isButtonEnabled()===true ? '': ' disabled'}`} type="submit">Загрузить</button>
                                  }
                                  <OverlayTrigger trigger="click" placement="left" overlay={popoverLeft} rootClose>
                                  <span className="help-link pull-right popover-help" data-content={help_text} data-toggle="popover">
                                      <i className="material-icons">help_outline</i></span>
                                  </OverlayTrigger>
                              </form>

                          </div>
                      </div>

                  </div>
          </div>
      }
     </div>
)}

const mapStateToProps = state => ({
    nuser: state.nuser,
})

const mapDispatchToProps = dispatch => bindActionCreators({fetchCartItems, setCartState}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NExcelFile)